export enum JobTitle {
    PersonalAssistantSecretary = 'PersonalAssistantSecretary',
    CustomerServiceAdvisor = 'CustomerServiceAdvisor',
    CallCentreAgent = 'CallCentreAgent',
    ClericalDataEntryWorker = 'ClericalDataEntryWorker',
    Electrician = 'Electrician',
    PlumberHeatingEngineer = 'PlumberHeatingEngineer',
    CarpenterJoiner = 'CarpenterJoiner',
    BuilderConstructionWorker = 'BuilderConstructionWorker',
    MechanicVehicleTechnician = 'MechanicVehicleTechnician',
    MaintenanceTechnician = 'MaintenanceTechnician',
    RetailAssistant = 'RetailAssistant',
    StoreSupervisor = 'StoreSupervisor',
    HospitalityWorker = 'HospitalityWorker',
    CateringKitchenWorker = 'CateringKitchenWorker',
    LeisureFitnessWorker = 'LeisureFitnessWorker',
    DeliveryDriverCourier = 'DeliveryDriverCourier',
    ProfessionalDriver = 'ProfessionalDriver',
    WarehouseLogisticsWorker = 'WarehouseLogisticsWorker',
    DoctorMedicalPractitioner = 'DoctorMedicalPractitioner',
    NurseMidwife = 'NurseMidwife',
    HealthcareAssistant = 'HealthcareAssistant',
    CareWorkerSupportWorker = 'CareWorkerSupportWorker',
    HeadteacherPrincipal = 'HeadteacherPrincipal',
    DeputyHeadteacherAssistantHeadteacher = 'DeputyHeadteacherAssistantHeadteacher',
    Teacher = 'Teacher',
    TeachingAssistant = 'TeachingAssistant',
    EarlyYearsChildcareWorker = 'EarlyYearsChildcareWorker',
    Professor = 'Professor',
    LecturerAcademic = 'LecturerAcademic',
    DesignerCreativeProfessional = 'DesignerCreativeProfessional',
    MediaMarketingProfessional = 'MediaMarketingProfessional',
    JournalistWriter = 'JournalistWriter',
    HairdresserBeautyTherapist = 'HairdresserBeautyTherapist',
    FreelancerIndependentContractor = 'FreelancerIndependentContractor',
    HomemakerUnpaidCarer = 'HomemakerUnpaidCarer',
    Other = 'Other',
}